import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-action-menu-divider',
  template: `
    <hr class="app-action-menu__divider" [ngClass]="customClass" />
  `,
  styleUrls: ['./app-action-menu.component.scss'],
})
export class AppActionMenuDividerComponent {
  @Input() customClass: string = '';
}
